<app-default-layout
  [title]="'AUTHENTICATION.ACTIVATION.TITLE'"
>
  <div class="row">
    <div class="col-md-8 offset-md-2">
      <p class="mb-4 text-muted">
        {{this.infoText}}
      </p>

    </div>
  </div>
</app-default-layout>
